import React from 'react';
import { CalendarRegular, CalendarCheckmarkCenterRegular } from '@fluentui/react-icons';
import ProcessStatus from '../../../utils/types/ProcessStatus';

interface IMenuItemData {
  key: ProcessStatus;
  text: React.ReactNode;
  onClick: () => void;
  icon?: React.ReactNode;
}
const iconStyle = { display: 'flex', alignItems: 'center', gap: 8 };

function processCurrentDropdownProps(
  onFilterUpdate: (status: ProcessStatus) => void,
): IMenuItemData[] {
  return [
    {
      key: ProcessStatus.Active,
      text: (
        <span style={iconStyle}>
          <CalendarCheckmarkCenterRegular />
          {`${ProcessStatus.Active} Processes`}
        </span>
      ),
      onClick: () => onFilterUpdate(ProcessStatus.Active),
    },
    {
      key: ProcessStatus.Complete,
      text: (
        <span style={iconStyle}>
          <CalendarRegular />
          {`${ProcessStatus.Complete} Processes`}
        </span>
      ),
      onClick: () => onFilterUpdate(ProcessStatus.Complete),
    },
  ];
}
export default processCurrentDropdownProps;
